import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import { deleteNotificationParameter } from "../../services/notification_parameters";


interface IPayload {
    id: number;
    setIsProcessing: React.Dispatch<React.SetStateAction<boolean>>;
    setApiError: React.Dispatch<React.SetStateAction<string | null>>;
};

const useDeleteNotificationParameter = () => {
    const queryClient = useQueryClient();

    const mutationFn = async (payload: IPayload) => {
        return await deleteNotificationParameter(payload.id);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
            variables.setApiError(null);
        },
        onSuccess: (status: number, variables: IPayload) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["custom_notifications"] });
                toast.success("Notification Parameter deleted successfully!");
            }
            variables.setIsProcessing(false);
            variables.setApiError(null);
        },
        onError: (error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
            variables.setApiError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        },
        onSettled: (status: number | undefined, error: any, variables: IPayload) => {
            if (status === 200) {
                variables.setIsProcessing(false);
                variables.setApiError(null);
            }
        }
    });
};
export default useDeleteNotificationParameter;